import { DropdownEditor, DropdownListItemProps } from '@approvalmax/ui';
import { domain } from 'modules/data';
import { FC } from 'react';

const BeneficiaryListItem: FC<DropdownListItemProps<domain.AirwallexBeneficiary>> = (props) => {
    return (
        <DropdownEditor.ListItem {...props}>
            {(text, item: domain.AirwallexBeneficiary) => {
                const accountLastDigits = (
                    item.bankDetails.iban ||
                    item.bankDetails.accountNumber ||
                    item.bankDetails.accountingRoutingValue1 ||
                    ''
                ).slice(-4);

                return (
                    <div>
                        <b>{text}</b>

                        <div>
                            <span>{item.bankDetails.bankCountryCode}</span>

                            <span> &middot; </span>

                            <span>{item.accountCurrency}</span>

                            <span> &middot; </span>

                            <span>{item.paymentMethod?.text}</span>

                            {accountLastDigits && (
                                <>
                                    <span> &middot; </span>

                                    <span>
                                        &bull;&bull;&bull;&bull;
                                        {accountLastDigits}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                );
            }}
        </DropdownEditor.ListItem>
    );
};

export default BeneficiaryListItem;
